export default __webpack_public_path__ + "static/media/Achats.cada7f7c.jpg";